import { healthProfileNewEntry } from "@/services/core-api-adapter";

/** BMI height allowed range: 1 m (100 cm) to 2.5 m (250 cm). */
export const BMI_HEIGHT_MIN_CM = 100;
export const BMI_HEIGHT_MAX_CM = 250;

export type HealthProfileVitalQuestionType =
  | "Pulse"
  | "BreathingRate"
  | "SystolicBloodPressure"
  | "DiastolicBloodPressure"
  | "Weight"
  | "Height";

export interface SubmitHeightOptions {
  unit: "CM" | "M";
}

/**
 * Submits a single health profile entry via the new-entry endpoint.
 * Use for vitals (Pulse, BreathingRate, BP) and BMI (Weight, Height).
 * For Height, pass options.unit so the API receives the correct unit.
 */
export function submitHealthProfileEntry(
  questionType: Exclude<HealthProfileVitalQuestionType, "Height">,
  value: string | number
): Promise<unknown>;
export function submitHealthProfileEntry(
  questionType: "Height",
  value: string | number,
  options: SubmitHeightOptions
): Promise<unknown>;
export function submitHealthProfileEntry(
  questionType: HealthProfileVitalQuestionType,
  value: string | number,
  options?: SubmitHeightOptions
): Promise<unknown> {
  const payload =
    questionType === "Height" && options?.unit
      ? { value: String(value), unit: options.unit }
      : { value: String(value) };
  return healthProfileNewEntry(questionType, { value: payload });
}
